import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  addReelVideo,
  clearReelVideoStatus,
} from 'slice/reelVideoSlice';
import ReelVideoForm from './ReelVideoForm';

const Add = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, lastAction } = useSelector((state) => state.reelVideo);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    dispatch(clearReelVideoStatus());
    setHasSubmitted(false);
  }, [dispatch]);

  useEffect(() => {
    if (hasSubmitted && lastAction === 'add' && !loading && !error) {
      toast('Reel video added successfully!');
      dispatch(clearReelVideoStatus());
      setHasSubmitted(false);
      navigate('/reel-video');
    }
  }, [dispatch, error, hasSubmitted, lastAction, loading, navigate]);

  const handleSubmit = (payload) => {
    setHasSubmitted(true);
    dispatch(addReelVideo(payload));
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Reel Video</h4>
      </div>
      <ReelVideoForm loading={loading} onSubmit={handleSubmit} submitLabel="Add Reel Video" />
    </div>
  );
};

export default Add;
